function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M65.3 276.5c-14.3-.2-28.4-2.1-42.2-5.8l-8.2-2.1-2.1-8.2c-10.2-40.2-6.9-72.7 9.8-96.7 13.8-19.9 33.4-28.7 46-32.4 1.9-16.3 9.3-31.5 20.9-43.1 10.6-10.6 25.2-17.3 41.8-19.4 3.7-12.6 12.5-32.3 32.5-46.2 24-16.7 56.6-20 96.7-9.8l8.2 2.1 2.1 8.2c10.2 40.2 6.9 72.7-9.8 96.7-13.9 20-33.6 28.8-46.2 32.5-2.1 16.6-8.8 31.2-19.4 41.8-11.6 11.6-26.8 18.9-43.1 20.9-3.8 12.6-12.6 32.2-32.4 46-15.1 10.3-33.3 15.5-54.6 15.5zM38.4 245c27.6 5.7 49.4 3.2 64.8-7.3 20.2-13.8 23.3-37.9 23.4-38.2l1.5-13.4 13.4.8c12.5.6 24.8-4.1 33.7-12.9 7.5-7.5 11.8-19.6 11.7-33.1l-.1-12.8 12.8-1.4c.2 0 24.3-3.2 38.1-23.4 10.6-15.4 13-37.2 7.3-64.8-27.8-5.7-49.7-3.2-65.1 7.5-19.9 13.9-23.1 37.7-23.1 37.9l-1.4 12.8-12.8-.1h-.3c-13.4 0-25.4 4.3-32.8 11.7-8.9 8.9-13.6 21.1-12.9 33.7l.7 13.4-13.4 1.5c-.2 0-24.3 3.2-38.1 23.4-10.6 15.3-13 37.1-7.4 64.7z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "202.9",
  cy: "81.4",
  r: "31.7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "143.1",
  cy: "141.3",
  r: "31.7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "79.3",
  cy: "205",
  r: "31.7"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-80.781 238.097 244.467)",
  cx: "238.1",
  cy: "244.5",
  r: "31.2"
})));